import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import { findOnArray, summarizer } from 'utils/functions';
import { toastWarning } from 'utils/toast';
import Dropdown from 'components/Dropdown';
import Loader from 'components/Loader';
import Button from 'components/Button';
import api from 'services/api';
import moment from 'moment';

const Compensação = ({
  drops,
  onSubmit,
  isCheque,
  cadastro_id,
  isPagamento,
  isRecebimento,
}) => {
  const defaultValues = {
    forma_pagto_id: null,
    itens: [],
    selected: [],
    loading: false,
  };
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues,
  });
  const drop = drops?.FormaDePagamento?.filter((f) => {
    if (isPagamento) {
      return (
        f?.modalidade === '90-SEM PAGAMENTO' &&
        f?.modulo !== 'VENDAS' &&
        f?.modulo !== 'CHEQUES'
      );
    } else if (isRecebimento) {
      return (
        f?.modalidade === '90-SEM PAGAMENTO' &&
        f?.modulo !== 'COMPRAS' &&
        f?.modulo !== 'CHEQUES'
      );
    } else if (isCheque) {
      return f?.modalidade === '90-SEM PAGAMENTO' && f?.modulo === 'CHEQUES';
    } else {
      return f?.modalidade === '90-SEM PAGAMENTO';
    }
  });

  const loadItens = async () => {
    if (!isCheque) {
      try {
        setValue('loading', true);
        setValue('selected', []);
        const { data } = await api.get(`/Financeiro/Pendencias/Compensacao`, {
          params: { cadastro_id },
        });
        if (isRecebimento) {
          setValue(
            'itens',
            data?.compensacoes?.filter((f) => f?.grupo === 'PAGAMENTOS')
          );
        } else if (isPagamento) {
          setValue(
            'itens',
            data?.compensacoes?.filter((f) => f?.grupo === 'RECEBIMENTOS')
          );
        } else {
          setValue('itens', data?.compensacoes);
        }
      } catch (error) {
      } finally {
        setValue('loading', false);
      }
    }
  };

  const onAddLancamento = ({ forma_pagto_id, selected, itens }) => {
    if (!Boolean(forma_pagto_id)) {
      return toastWarning('Selecione uma forma de pagamento');
    }
    if (Boolean(selected?.length)) {
      const compensacoes = selected?.map((s) => {
        const compensacao = itens?.find((f) => f?.id === s);
        return {
          financeiro_id: compensacao?.id,
          valor: compensacao?.valor_pendente,
        };
      });
      const data = {
        valor: summarizer(compensacoes, 'valor'),
        compensacoes,
        forma_pagto_id,
        forma_pagto: findOnArray(forma_pagto_id, drop, 'label'),
      };
      onSubmit(data);
    }
  };

  useEffect(() => {
    loadItens();
  }, []);

  if (watch('loading')) {
    return <Loader />;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Dropdown
          name="forma_pagto_id"
          control={control}
          label="Forma de Pagamento"
          options={drop}
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={watch('itens')}
          columns={[
            {
              field: 'filial',
              headerName: 'Filial',
              flex: 2,
              sortable: false,
            },
            {
              field: 'documento',
              headerName: 'Documento',
              flex: 1,
              sortable: false,
            },
            {
              field: 'dtemissao',
              headerName: 'Data de Emissão',
              flex: 1,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'dtvenc',
              headerName: 'Data de Vencimento',
              flex: 1,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'parcela',
              headerName: 'Parcela',
              type: 'number',
              flex: 1,
              sortable: false,
            },
            {
              field: 'valor_pendente',
              headerName: 'Valor Pendente',
              type: 'number',
              flex: 1,
              sortable: false,
              valueGetter: ({ value }) =>
                value &&
                value?.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                }),
            },
          ]}
          hideFooter
          autoHeight
          density="compact"
          disableSelectionOnClick
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          checkboxSelection
          keepNonExistentRowsSelected
          localeText={{ noRowsLabel: 'Nenhum Registro.' }}
          selectionModel={watch('selected')}
          onSelectionModelChange={(ids) => setValue('selected', ids)}
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(onAddLancamento)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default Compensação;
